import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  Lookup,
} from "devextreme-react/data-grid";
import { FillFilters, GetDatePartOnly, GetFormatedDateWithTime } from '../../../../common/Utils'
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "24CF6183-2364-47CA-B257-59A844FCB8B5";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const initialFormFields = {
        ExpressionCode: '',
        Description: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].RowId;
        }
        else {
            rowId.current = '';
        }

        setIsEditButtonDisabled(!isEditButtonDisabled);
    };

    const handelEditClick = () => {
        const buttonUrl = "/wm/codes/edit-evaluation-expression?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        // Reload datasource with current formFields to trigger server-side filtering
        let datasource = loadDatasource();
        const filters = FillFilters(formFields);
        datasource.filter(filters);
        setResultData(datasource);
    };
    
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        // Reload datasource with reset fields
        setTimeout(() => {
            setResultData(loadDatasource());
        }, 100);
    }
    
    useEffect(() => {
        // Initialize datasource on mount
        if (!resultData) {
            setResultData(loadDatasource());
        }
    }, []);

    const handleFormLoad = useCallback(() => {
       // Load any lookup data here if needed
    }, []);

    const handleFieldChange = useCallback((name, value) => {
        // Handle field changes if needed
    }, []);

    const loadDatasource = () => {
        var url = "wm/EvaluationExpression/GetEvaluationExpressions";
        let store = createStore({
            key: 'RowId',
            loadParams: formFields,
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    }
    
    const [resultData, setResultData] = useState(null);

    // Simple search layout - can be replaced with a proper Layout file later
    const SearchLayout = [
        {
            "groupId": 1,
            "fields": [
                {
                    "name": "ExpressionCode",
                    "tableName": "",
                    "label": "Expression Code",
                    "type": "text",
                    "required": false,
                    "visible": true,
                    "isLabelChanged": false,
                },
                {
                    "name": "Description",
                    "tableName": "",
                    "label": "Description",
                    "type": "text",
                    "required": false,
                    "visible": true,
                    "isLabelChanged": false,
                }
            ]
        },
        
    ];

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Manage Evaluation Expression
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='4189807C-C746-4516-9849-3349DB79066D'
                                layoutName='WMEvaluationExpressionSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="single" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <Column dataType="string" caption='Record #' dataField='RecordNumber'  />
                        <Column visible={false} dataType="date" caption='Created Date' dataField='CreationDateTime'  />
                        <Column visible={false} dataType="string" caption='Created By' dataField='CreationUserId'  />
                        <Column visible={false} dataType="date" caption='Last Updated' dataField='LastUpdateDateTime'  />
                        <Column visible={false} dataType="string" caption='Last Updated By' dataField='LastUpdateUserId'  />
                        <Column visible={false} dataType="string" caption='Company ID' dataField='CompanyId'  />
                        <Column visible={false} dataType="string" caption='Module' dataField='Module'  />
                        <Column visible={false} dataType="string" caption='Record Type' dataField='RecordType'  />
                        <Column dataType="string" caption='Expression Code' dataField='ExpressionCode'  />
                        <Column dataType="string" caption='Description' dataField='Description'  />
                        <Column dataType="string" caption='Status' dataField='Status'  />
                        <Column visible={false} dataType="number" caption='Key Sequence' dataField='KeySequence'  />

                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handelEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <div>
                                    <Link to="/wm/codes/add-evaluation-expression">
                                        <Button
                                            type="default"
                                            className="gridTopButton"
                                            text="Create"
                                        ></Button>
                                    </Link>
                                </div>
                            </GridToolbarItem>
                             <GridToolbarItem location="after">
                             <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                            </GridToolbarItem>
                            <GridToolbarItem name="exportButton" />
                            <GridToolbarItem name="columnChooserButton" />
                        </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);

